<template>
    <v-container fluid>
        <v-card>
            <v-card-text>
                <v-row v-if="hasImport && !hasCardView">
                    <v-file-input @change="importExcelFile" ref="file" style="display: none" :key="'fileKey' + fileKey" />
                    <v-btn v-if="hasImport && hasClaim(claimName, true)" color="quinary" dark class="ml-2 mb-2 float-right" @click="$refs.file.$refs.input.click()">Import from Excel</v-btn>
                    <v-btn v-if="hasImport && hasClaim(claimName, true)" color="tertiary" dark class="ml-2 mb-2 float-right" @click="downloadTemplate()">Download Template</v-btn>
                </v-row>
                <template v-if="!isAudit && !hasCardView || cards.length < 2">
                    <div class="row">
                        <div class="column left" v-if="!isAudit && !removeForm">
                            <component :is="mainForm" :readonly="!canEdit(claimName)" :filter="tableFilter" v-model="item" v-on:delete="goBack" v-on:save="goBack" v-on:cancel="goBack" />
                        </div>
                        <div class="column right">
                            <v-tabs show-arrows>
                                <slot name="firstTab" />
                                <template v-for="(tab, i) in tabs">
                                    <v-tab :key="tab.text">{{ tab.text }}</v-tab>
                                    <v-tab-item :key="i">
                                        <component :is="tab.table" :filter="getTabFilter(tab.value)" :refresh-key="refreshKey" />
                                    </v-tab-item>
                                </template>
                                <slot name="lastTab" />
                            </v-tabs>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <v-row>
                        <v-col>
                            <v-tabs show-arrows>
                                <v-tab v-if="cards.length > 1 && !isAudit">Cards</v-tab>
                                <v-tab-item v-if="!isAudit && cards.length > 1 && hasCardView">
                                    <card-view-base :item="item" :filter="filter" :cards="cards" :has-import="hasImport" :claim-name="claimName" />
                                </v-tab-item>
                                <slot name="firstTab" />
                                <template v-for="(tab, i) in tabs">
                                    <v-tab v-if="!tab.isCard || tab.isCard && isAudit || !hasCardView" :key="tab.text">{{ tab.text }}</v-tab>
                                    <v-tab-item v-if="!tab.isCard || tab.isCard && isAudit || !hasCardView" :key="i">
                                        <component :is="tab.table" :filter="getTabFilter(tab.value)" :refresh-key="refreshKey" />
                                    </v-tab-item>
                                </template>
                                <slot name="lastTab" />
                            </v-tabs>
                        </v-col>
                    </v-row>
                </template>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import store from '../store/store'
    import exporter from '../export/exporter'

    export default {
        props: [
            'filter',
            'tabs',
            'claimName',
            'apiMethod',
            'mainForm',
            'cards',
            'mainCard',
            'hasCardView',
            'itemId',
            'refreshKey',
            'hasImport',
            'removeForm'
        ],

        components: {
            cardViewBase: () => import('../components/CardViewBase')
        },

        data() {
            return {
                id: null,
                item: {}
            }
        },

        async mounted() {
            if (this.itemId !== null && typeof (this.itemId) !== "undefined") {
                this.id = this.itemId;
            }
            else {
                this.id = this.$route.params.id;
                var response = await axios.get('/api/' + this.apiMethod + '/' + this.id);
                this.item = response.data;
            }
        },

        methods: {
            goBack() {
                this.$router.go(-1);
            },
            getTabFilter(value) {
                var filter = this.getFilter(this.filter);
                filter[value] = this.id;
                return filter;
            },
            async importExcelFile(excelFile) {
                try {
                    var formData = new FormData();
                    formData.append("file", excelFile);
                    this.isLoading = true;
                    await axios.post('/api/' + this.cards[0].apiMethod + '/ImportChildren/' + this.item.id, formData);
                    store.dispatch('alert/success', 'Records imported successfully')
                    this.fileKey++;
                    await this.load();
                }
                catch (error) {
                    if (error.response && error.response.status == 400) {
                        store.dispatch('alert/error', "Server returned an error.\n" + error.response.data);
                    } else {
                        store.dispatch('alert/error', `Something went wrong: ${error}`);
                    }
                }
                finally {
                    this.isLoading = false;
                }
            },
            downloadTemplate() {
                return axios
                    .get('/api/' + this.cards[0].apiMethod + '/ChildrenTemplate', { responseType: 'blob' })
                    .then(exporter.saveBlob)
                    .catch((error) => { store.dispatch('alert/error', 'There was an error downloading the file. ' + error) });
            },
            downloadUrl(url, name) {
                fetch(url)
                    .then(resp => resp.blob())
                    .then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url;
                        // the filename you want
                        a.download = name;
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                    })
                    .catch(() => alert('oh no!'));
            },
        },

        computed: {
            tableFilter() {
                return this.getFilter(this.filter)
            },
            isAudit() {
                return this.$route.name == "auditEditor";
            }
        },

        watch: {
            itemId: {
                handler() {
                    this.id = this.itemId;
                }
            }
        }
    };
</script>
<style scoped>
    .column {
        float: left;
        padding: 10px;
    }

    .full {
        width: 100%;
    }

    .left {
        width: 25%;
    }

    .right {
        width: 75%;
    }

    /* Clear floats after the columns */
    .row:after {
        content: "";
        display: table;
        clear: both;
    }

    /* Responsive layout - makes the two columns stack on top of each other instead of next to each other */
    @media screen and (max-width: 1500px) {
        .column {
            width: 100%;
        }
    }
</style>
